import { render, staticRenderFns } from "./learnings.vue?vue&type=template&id=1f4e5d36&"
import script from "./learnings.vue?vue&type=script&lang=js&"
export * from "./learnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports